<script setup lang="ts">
import { computed } from "vue";
import type { Component } from "vue";
import type { ActivityVariant } from "./ActivityLogStyle";

const props = defineProps<{
  variant?: ActivityVariant;
  icon: Component;
}>();

const VARIANT_BACKGROUNDS: Record<ActivityVariant, string> = {
  default: "tw:bg-gray-200",
  success: "tw:bg-emerald-500",
  warning: "tw:bg-amber-500",
  danger: "tw:bg-[#fb2424]",
};

const backgroundClass = computed<string>(() => VARIANT_BACKGROUNDS[props.variant ?? "default"]);
</script>

<template>
  <span
    class="tw:flex tw:h-8 tw:w-8 tw:items-center tw:justify-center tw:rounded-full"
    :class="backgroundClass"
  >
    <component :is="props.icon" class="tw:h-4 tw:w-4 tw:text-white" />
  </span>
</template>
